var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('fieldset', [_c('legend', [_vm._v("Override User Module Access")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('label', [_vm._v("Project Name")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "id": "form_errors"
    }
  }), _c('br'), _vm._v(" "), _vm._l((_vm.listProjectData), function(project_obj, index) {
    return _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-12 "
    }, [_c('div', {
      staticClass: "col-md-3 float-md-left "
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.projectidchk[project_obj.projectid]),
        expression: "form.projectidchk[project_obj.projectid]"
      }],
      class: {
        'form-control': true, 'error': _vm.errors.has('projectIdCheck')
      },
      staticStyle: {
        "font-weight": "100",
        "width": "13px",
        "float": "left",
        "margin-right": "10px",
        "margin-top": "4px"
      },
      attrs: {
        "type": "checkbox",
        "name": "projectIdCheck",
        "id": project_obj.projectid,
        "id": project_obj.projectid
      },
      domProps: {
        "value": _vm.form.projectidchk[project_obj.projectid],
        "checked": Array.isArray(_vm.form.projectidchk[project_obj.projectid]) ? _vm._i(_vm.form.projectidchk[project_obj.projectid], _vm.form.projectidchk[project_obj.projectid]) > -1 : (_vm.form.projectidchk[project_obj.projectid])
      },
      on: {
        "click": function($event) {
          _vm.getProjectModuleTree(project_obj.projectid, index, $event, project_obj.roleid, 'add')
        },
        "__c": function($event) {
          var $$a = _vm.form.projectidchk[project_obj.projectid],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = _vm.form.projectidchk[project_obj.projectid],
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.form.projectidchk[project_obj.projectid] = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.form.projectidchk[project_obj.projectid] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.form.projectidchk, project_obj.projectid, $$c)
          }
        }
      }
    }), _vm._v(" " + _vm._s(project_obj.projectname)), _c('br'), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('projectIdCheck')),
        expression: "errors.has('projectIdCheck')"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Please assign at least one Project.")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6 float-md-left"
    }, [_c('treeselect', {
      class: 'treeselect_' + project_obj.projectid,
      attrs: {
        "multiple": true,
        "options": _vm.options[project_obj.projectid],
        "disable-branch-nodes": false,
        "value": _vm.form.values[project_obj.projectid],
        "search-nested": ""
      },
      model: {
        value: (_vm.form.values[project_obj.projectid]),
        callback: function($$v) {
          _vm.$set(_vm.form.values, project_obj.projectid, $$v)
        },
        expression: "form.values[project_obj.projectid]"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "text-danger",
      attrs: {
        "id": 'treeselect_err_' + project_obj.projectid
      }
    })], 1)])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "userfooter form-actions"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "size": "vlg"
    }
  }, [_vm._v("Save")]), _vm._v(" \n            ")])])])])], 1), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "active": _vm.show,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#FF6700"
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7df82774","hasScoped":true}!./src/views/components/appUserProjectRoles/appuserprojectroles.component.html
// module id = 742
// module chunks = 1